import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/Sidebar.css';

function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  // Quyền: admin xem được tất cả; user thường theo mảng permissions
  const perms = Array.isArray(user.permissions) ? user.permissions : [];
  const can = (module) => user.role === 'admin' || perms.includes(module);

  const isActive = (path) => (location.pathname === path ? 'active' : '');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <div className="sidebar">
      {/* Logo */}
      <div className="sidebar-logo">
        <div className="logo-icon">ZNS</div>
        <div className="logo-text">
          <h3>ZNS Management</h3>
          <p>Công ty TNHH NAGEN</p>
        </div>
      </div>

      {/* Menu chính */}
      <nav className="sidebar-nav">
        {can('dashboard') && (
          <Link to="/dashboard" className={`menu-item ${isActive('/dashboard')}`}>
            <span className="icon">📊</span><span>Dashboard</span>
          </Link>
        )}
        {can('send_zns') && (
          <Link to="/send-zns" className={`menu-item ${isActive('/send-zns')}`}>
            <span className="icon">📤</span><span>Gửi ZNS đơn lẻ</span>
          </Link>
        )}
        {can('send_bulk') && (
          <Link to="/send-bulk-zns" className={`menu-item ${isActive('/send-bulk-zns')}`}>
            <span className="icon">📨</span><span>Gửi hàng loạt</span>
          </Link>
        )}
        {can('templates') && (
          <Link to="/templates" className={`menu-item ${isActive('/templates')}`}>
            <span className="icon">📝</span><span>Quản lý Template</span>
          </Link>
        )}
        {can('automation') && (
          <Link to="/automation" className={`menu-item ${isActive('/automation')}`}>
            <span className="icon">⚙️</span><span>Automation Rules</span>
          </Link>
        )}
        {can('history') && (
          <Link to="/history" className={`menu-item ${isActive('/history')}`}>
            <span className="icon">🗂️</span><span>Lịch sử gửi tin</span>
          </Link>
        )}

        {/* Khu vực quản trị */}
        {(can('users') || can('settings')) && (
          <>
            <div className="menu-divider" />
            <div className="menu-section-title">QUẢN TRỊ</div>
          </>
        )}
        {can('users') && (
          <>
            <Link to="/users" className={`menu-item ${isActive('/users')}`}>
              <span className="icon">👥</span><span>Quản lý User</span>
            </Link>
            <Link to="/activity-logs" className={`menu-item ${isActive('/activity-logs')}`}>
              <span className="icon">📜</span><span>Nhật ký hoạt động</span>
            </Link>
          </>
        )}
        {can('settings') && (
          <Link to="/settings" className={`menu-item ${isActive('/settings')}`}>
            <span className="icon">🔧</span><span>Cài đặt hệ thống</span>
          </Link>
        )}
      </nav>

      {/* Footer user — dùng đúng class của Sidebar.css gốc */}
      <div className="sidebar-footer">
        <div className="user-info">
          <div className="user-avatar">
            {(user.full_name || user.username || 'U')[0].toUpperCase()}
          </div>
          <div className="user-details">
            <div className="user-name">{user.full_name || user.username}</div>
            <div className="user-role">{user.role === 'admin' ? 'Quản trị viên' : 'Người dùng'}</div>
          </div>
        </div>
        <button className="logout-btn" onClick={handleLogout} title="Đăng xuất">⏻</button>
      </div>
    </div>
  );
}

export default Sidebar;